import React, { useState, useEffect } from "react";
import { Card } from "semantic-ui-react";
import ErrorBoundary from "../../BCErrorBoundary";
import "../../../styles/lms/lms-global.scss";
import LmsTabMenuBar from "./LmsTabMenuBar";
import { useLocalStorage, usePromiseAll } from "../../../helpers/GlobalHelper";

interface ITabPagesProps {
  tabPages: Record<string, JSX.Element>;
  menuBreakIndex?: number
  initTab?: string
  isNested?: boolean
  refreshDependency?: any
}

const LmsTabPages = ({ ...props }: ITabPagesProps) => {
  const [tabs, setTabs] = useState([] as any[]);
  const tabKeysString = Object.keys(props.tabPages).join("");
  const [tableTablePagesSuffixes, setTableTablePagesSuffixes] = useState([] as any[]);
  const [tabPages, setTabPages] = useState({});
  const menuBreakIndex = props.menuBreakIndex || 0;

  useEffect(() => {
    const tabPagesTemp = {};
    const tableSuffixTemp = [] as any[];
    const tabsTemp = [] as any[];
    Object.entries(props.tabPages)?.map(([tabName, pageContent]) => {
      const tabNameUpper = tabName?.toUpperCase();
      const tableSuffix = pageContent?.props?.suffix || pageContent?.props?.apiSuffix;
      if (tableSuffix) {
        tableSuffixTemp.push(tableSuffix);
      }

      tabPagesTemp[tabNameUpper] = { pageContent, suffix: pageContent?.props?.suffix || pageContent?.props?.apiSuffix };
      tabsTemp.push({ name: tabNameUpper });
    });

    setTabPages(tabPagesTemp);
    setTabs(tabsTemp);

    if (tableSuffixTemp.length > 0) {
      setTableTablePagesSuffixes(tableSuffixTemp);
    }
  }, [tabKeysString, props.refreshDependency]);

  const [activeTab, setActiveTab] = useLocalStorage(`${window?.location?.pathname}activeTab${props.isNested ? "-nested" : ""}`, tabs[0]?.name, "session");

  useEffect(() => {
    if (props?.initTab && activeTab !== props.initTab?.toUpperCase()) {
      setActiveTab(props.initTab?.toUpperCase());
    }
  }, [props.initTab]);

  const { promisesData: allData } = usePromiseAll(tableTablePagesSuffixes, { isReady: tableTablePagesSuffixes?.length > 0, defaultData: [] });

  useEffect(() => {
    if (allData) {
      setTabs((prevTabs) =>
        prevTabs.map(({ name }) => {
          const tabTableData = allData[tabPages[name].suffix];
          if (tabTableData) return { name, tableLength: tabTableData.length, suffix: tabPages[name].suffix };
          return { name, suffix: tabPages[name].suffix };
        })
      );
    }
  }, [allData, props.refreshDependency]);

  return (
    <React.Fragment>
      {tabs.length > 0 && <Card fluid className="lms-overflow-x-scroll">
        <div style={{ minWidth: `${(tabs?.length || 1) * 85}px` }}>
          <Card.Content>
            <LmsTabMenuBar
              tabs={tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              menuBreakIndex={menuBreakIndex}
            />
            <ErrorBoundary>
              <Card.Description>{tabPages[activeTab]?.pageContent}</Card.Description>
            </ErrorBoundary>
          </Card.Content>
        </div>
      </Card>}
    </React.Fragment>
  );
};

export default LmsTabPages;